var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "pop-dialog pop-set-table",
      attrs: {
        title: "列表控制",
        visible: _vm.visibleDialog,
        width: "678px",
        top: "calc(50vh - 240px)",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleDialog = $event
        },
      },
    },
    [
      _c("div", { staticClass: "table-list-top" }, [
        _c(
          "div",
          { staticClass: "primary", on: { click: _vm.onResetDefault } },
          [_vm._v("恢复默认")]
        ),
        _c("span", { staticClass: "space" }, [_vm._v("|")]),
        _c("div", { staticClass: "primary", on: { click: _vm.onShowAll } }, [
          _vm._v("全部显示"),
        ]),
        _c("span", { staticClass: "space" }, [_vm._v("|")]),
        _c("div", { staticClass: "primary", on: { click: _vm.onFreezeAll } }, [
          _vm._v("全部解冻"),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "table-list table-mini" },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tableList,
                "row-class-name": _vm.tableRowClassName,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "排序", width: "50" },
              }),
              _c("el-table-column", {
                attrs: { prop: "label", label: "列名", width: "168" },
              }),
              _c("el-table-column", {
                attrs: { label: "对齐方式", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            staticClass: "select-align",
                            attrs: { placeholder: "请选择", size: "mini" },
                            model: {
                              value: scope.row.align,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "align", $$v)
                              },
                              expression: "scope.row.align",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "居中", value: "center" },
                            }),
                            _c("el-option", {
                              attrs: { label: "左对齐", value: "left" },
                            }),
                            _c("el-option", {
                              attrs: { label: "右对齐", value: "right" },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "显示列", width: "85" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: { size: "mini" },
                          on: { change: _vm.onShowColumn },
                          model: {
                            value: scope.row.show,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "show", $$v)
                            },
                            expression: "scope.row.show",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "冻结列", width: "85" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: { size: "mini" },
                          on: {
                            change: function ($event) {
                              return _vm.onFreeze($event, scope.row.order)
                            },
                          },
                          model: {
                            value: scope.row.freeze,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "freeze", $$v)
                            },
                            expression: "scope.row.freeze",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "btn-con" }, [
                          scope.$index !== 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "primary",
                                  on: {
                                    click: function ($event) {
                                      return _vm.onUp(scope.$index)
                                    },
                                  },
                                },
                                [_vm._v("上移")]
                              )
                            : _vm._e(),
                          scope.$index !== _vm.columns.length - 1
                            ? _c(
                                "div",
                                {
                                  staticClass: "primary",
                                  on: {
                                    click: function ($event) {
                                      return _vm.onDown(scope.$index)
                                    },
                                  },
                                },
                                [_vm._v("下移")]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  _vm.visibleDialog = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.onConfirm },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }